<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form"
            size="mini"
        >
            <el-form-item label="文件夹名称:" class="query-form-item">
                <el-input
                    v-model="query.filter.name"
                    placeholder="请输入分类名称"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
                <el-button type="success" icon="el-icon-plus" @click="add"
                    >添加文件夹</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            :height="tableHeight"
            stripe
            border
            style="width: 100%"
        >
            <el-table-column label="文件夹名字" min-width="250" align="center">
                <template slot-scope="scope">
                    <div @click="edit(scope.row)" class="pen">
                        {{ scope.row.name }}
                        <i class="el-icon-edit" style="margin-left: 3px;"></i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="关键词数量" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.kw_count }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="190"
                align="center"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="onkeyword(scope.row)"
                        >查看关键词</el-button
                    >
                    <el-button
                        size="mini"
                        type="success"
                        @click="edit(scope.row)"
                        >编辑</el-button
                    >
                    <el-button
                        size="mini"
                        type="danger"
                        @click="deleteBrand(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <add
            :visible="ctrl.addDialogVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></add>
        <edit
            :visible="ctrl.editDialogVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></edit>
        <keyword
            ref="keyword"
            :visible="ctrl.keywordDialogVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
            @Upload="onUpload"
            @onaddKeyword="onaddKeyword"
        ></keyword>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :KeywordID="KeywordID"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback2"
        ></upload>
        <add-keyword
            :visible="ctrl.addkeywordDialogVisible"
            :KeywordID="KeywordID"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback2"
        ></add-keyword>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import Add from "./add";
import Edit from "./edit";
import Keyword from "./keyword";
import Upload from "./upload";
import AddKeyword from "./add_Keyword";
export default {
    components: { Add, Edit, Keyword, Upload, AddKeyword },
    data() {
        return {
            ctrl: {
                addDialogVisible: false,
                keywordDialogVisible: false,
                uploadDialogVisible: false,
                addkeywordDialogVisible: false,
                editDialogVisible: false
            },
            tableHeight: null,
            formData: {},
            KeywordID: "",
            query: {
                filter: {}
            },
            list: [],
            loading: false
        };
    },
    created() {
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 100 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        100 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    },
    methods: {
        getList() {
            this.loading = true;
            api.kw_folder_all(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //查看文件夹下的关键词
        async onkeyword(data) {
            await this.$refs.keyword.Keywords(data);
            this.ctrl.keywordDialogVisible = true;
            this.ctrl.dialogTitle = `查看 ${data.name} 文件夹下的关键词`;
        },
        //添加文件夹
        add() {
            this.ctrl.addDialogVisible = true;
            this.ctrl.dialogTitle = "添加文件夹";
        },
        //编辑文件夹
        edit(data) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.ctrl.editDialogVisible = true;
            this.ctrl.dialogTitle = "编辑文件夹";
        },
        // 批量添加关键词
        onUpload(data) {
            this.KeywordID = data.id;
            this.ctrl.uploadDialogVisible = true;
            this.ctrl.dialogTitle = data.name + " 评论添加关键词";
        },
        // 添加关键词
        onaddKeyword(data) {
            this.KeywordID = data.id;
            this.ctrl.addkeywordDialogVisible = true;
            this.ctrl.dialogTitle = data.name + " 添加关键词";
        },
        //删除文件夹
        deleteBrand(data) {
            this.$confirm(`确定要删除 ${data.name} 这个文件夹吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.kw_folder_remove({ id: data.id }).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                type: "success",
                                message: "删除文件夹成功"
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        //重置
        onReset() {
            this.query = {
                filter: {}
            };
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addDialogVisible = false;
            this.ctrl.editDialogVisible = false;
            this.ctrl.keywordDialogVisible = false;
            if (isshow) return;
            this.getList();
        },
        closeCllback2(isshow) {
            this.ctrl.addkeywordDialogVisible = false;
            this.ctrl.uploadDialogVisible = false;
            if (isshow) return;
            this.$refs.keyword.Keywords_callback();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-button--mini {
    padding: 5px 5px !important;
}
.pen:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>
